<div class="modal-content confirm-phone-modal" [class.view-no]="currentView === 'no'">

    
    @if (currentView === 'do-confirm') {
    <div class="modal-body text-center pt-0">
      <div class="col-auto icon icon-size">
        <img src="../../../../../../assets/images/Icons/icons-message-blue.svg" alt="warning" aria-hidden="true"
          role="presentation" />
      </div>
      <h2 class="popup-title">{{ 'CONFIRM_PHONE_NUMBER' | globalTranslate }}</h2>
      <div class="popup-text">
        <div>{{ 'CONFIRM_PHONE_NUMBER_1' | globalTranslate }}</div>
        <div>{{ 'CONFIRM_PHONE_NUMBER_2' | globalTranslate }}</div>
      </div>
    
      <div class="phone-row"><span class="phone-text-do-confirm"><img alt="phone" aria-hidden="true" role="presentation"
            class="img-responsive img-book" src="../../../assets/images/Icons/icons-phone-blue.svg" />{{
          displayPhoneNumber }}</span>
      </div>
      <p class="popup-question">{{ 'CONFIRM_PHONE_NUMBER_3' | globalTranslate }}</p>
    </div>
    
    <div class="modal-footer align-button justify-content-center">
      <div class="me-2 ml-2 button-gap">
        <button type="button" id="dialog" class="btn d-grid btn-link" (click)="onNo()">
          {{ 'No' | globalTranslate }}
        </button>
      </div>
      <div class="me-2 ml-2">
        <button type="button" id="dialog" class="btn d-grid btn-secondary" (click)="onYes()">
          {{ 'Yes' | globalTranslate }}
        </button>
      </div>
    </div>
    }
      

    @if (currentView === 'yes') {
    <div class="modal-body text-center pt-0">
      <div class="col-auto icon icon-size">
        <img src="../../../../../../assets/images/Icons/icons-checkmark-green.svg" alt="warning" aria-hidden="true"
          role="presentation" />
      </div>
      <h2 class="popup-title">{{ 'CONFIRM_PHONE_NUMBER_4' | globalTranslate }}</h2>
      <div class="popup-text">
        <div>{{ 'CONFIRM_PHONE_NUMBER_5' | globalTranslate }}</div>
        <div>{{ 'CONFIRM_PHONE_NUMBER_6' | globalTranslate }}</div>
      </div>
    
      <div class="phone-row">
        <span class="phone-text-close"><img alt="phone" aria-hidden="true" role="presentation"
            class="img-responsive img-book" src="../../../assets/images/Icons/icons-phone-green.svg" />{{
          displayPhoneNumber }}
        </span>
      </div>
    </div>
    
    <div class="modal-footer align-button justify-content-center">
      <div class="me-2 ml-2">
        <button type="button" id="dialog" class="btn d-grid btn-link" (click)="onCloseAcknowledgement()">
          {{ 'Close' | globalTranslate }}
        </button>
      </div>
    </div>
    }


    @if (currentView === 'no') {
    <div class="modal-body text-center pt-0">
      <div class="col-auto icon icon-size">
        <img src="../../../../../../assets/images/Icons/icons-update-phone-number.svg" alt="warning" aria-hidden="true"
          role="presentation" />
      </div>
      <h2 class="popup-title">{{ 'CONFIRM_PHONE_NUMBER_7' | globalTranslate }}</h2>
      <div class="popup-text">
        <div>{{ 'CONFIRM_PHONE_NUMBER_8' | globalTranslate }}</div>
        <div>{{ 'CONFIRM_PHONE_NUMBER_9' | globalTranslate }}</div>
      </div>
      
      <nh-alert class="alert-block" type="primary" [isOpen]="true">
        <div class="row">
          <div class="col-auto icon">
            <img src="../../../../../../assets/images/Icons/icons-information-circle-outline-blue.svg" alt="warning"
              aria-hidden="true" role="presentation" class="icon-height" />
          </div>
          <div class="col message">
            <div class="alert-text-header"><strong [innerHTML]="'CONFIRM_PHONE_NUMBER_10' | globalTranslate"></strong></div>
            <div class="alert-text-font" [innerHTML]="'CONFIRM_PHONE_NUMBER_11' | globalTranslate"></div>
            <div class="alert-text-font" [innerHTML]="'CONFIRM_PHONE_NUMBER_12' | globalTranslate"></div>
            <div class="alert-text-font" [innerHTML]="'CONFIRM_PHONE_NUMBER_13' | globalTranslate"></div>
          </div>
        </div>
      </nh-alert> 
    
      <nh-field [attr.aria-required]="true" [isRow]="true" [mandatory]="true" class="label-section"
        label="{{ 'CONFIRM_PHONE_NUMBER_14' | globalTranslate }}" [attr.aria-label]="'CONFIRM_PHONE_NUMBER_14' | globalTranslate">
        <input type="text" name="newPhoneNumber" [formControl]="newPhoneNumber"
          [attr.aria-label]="'CONFIRM_PHONE_NUMBER_14' | globalTranslate" class="form-control mt-2" mask="000-000-0000"
          placeholder="XXX-XXX-XXXX" />
      </nh-field>
    
      <nh-field [attr.aria-required]="true" [isRow]="true" [mandatory]="true" class="label-section"
        label="{{ 'CONFIRM_PHONE_NUMBER_15' | globalTranslate }}" [attr.aria-label]="'CONFIRM_PHONE_NUMBER_15' | globalTranslate">
        <input type="text" name="confirmPhoneNumber" [formControl]="confirmPhoneNumber"
          [attr.aria-label]="'CONFIRM_PHONE_NUMBER_15' | globalTranslate" class="form-control mt-2" mask="000-000-0000"
          placeholder="XXX-XXX-XXXX" />
      </nh-field>
      <br>
    
    </div>
    
    <div class="modal-footer align-button justify-content-center button-width">
      @if (displayPhoneNumber) {
      <div class="me-2 ml-2 button-gap">
        <button type="button" id="dialog" class="btn d-grid btn-link" (click)="onCancel()">
          {{ 'CANCEL' | globalTranslate }}
        </button>
      </div>
      }
      <div class="me-2 ml-2">
        <button type="button" id="dialog" class="btn d-grid btn-secondary" (click)="onSubmit()" [disabled]="!isFormValid()">
          {{ "SUBMIT" | globalTranslate }}
        </button>
      </div>
    </div>
    }

</div>
